import { PercentInput } from 'cpool-components/input/PercentInput';
import type { Control, FieldValues, Path } from 'react-hook-form';

import { FormField } from './FormField';

type FormPercentInputProps<TFieldValues extends FieldValues> = {
    allowDecimals?: boolean;
    control: Control<TFieldValues>;
    disabled?: boolean;
    id: Path<TFieldValues>;
    label: string;
    labelClassName?: string;
    max?: number;
    min?: number;
};

export const FormPercentInput = <TFieldValues extends FieldValues>({
    allowDecimals,
    control,
    disabled,
    id,
    label,
    labelClassName = 'h-8 w-[175px] shrink-0 justify-start',
    max,
    min,
}: FormPercentInputProps<TFieldValues>) => (
    <FormField<TFieldValues, number | null> control={control} name={id}>
        {({ error, onChange, value }) => (
            <PercentInput
                id={id}
                label={label}
                value={value}
                onChange={onChange}
                min={min}
                max={max}
                allowDecimals={allowDecimals}
                disabled={disabled}
                labelClassName={labelClassName}
                className="w-full"
                error={error}
            />
        )}
    </FormField>
);
